import React from "react";
import {
  FiRefreshCw,
  FiSearch,
} from "react-icons/fi";

import {
  REQUIREMENT_PRIORITIES,
  REQUIREMENT_TYPES,
} from "./constants";

const RequirementFilters = ({
  filters,
  setFilters,
  loading,
  onSearch,
  onReset,
}) => {
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      onSearch();
    }
  };

  return (
    <div className="requirement-filter-card">

      <div className="requirement-filter-grid">

        {/* Search */}

        <div className="requirement-filter-item">

          <label>
            Search Customer
          </label>

          <input
            type="text"
            name="search"
            placeholder="Customer Name / Mobile"
            value={filters.search}
            onChange={handleChange}
            onKeyDown={handleKeyPress}
          />

        </div>

        {/* Requirement */}

        <div className="requirement-filter-item">

          <label>
            Requirement
          </label>

          <select
            name="requirementType"
            value={filters.requirementType}
            onChange={handleChange}
          >

            <option value="">
              All
            </option>

            {REQUIREMENT_TYPES.map((item) => (

              <option
                key={item}
                value={item}
              >
                {item}
              </option>

            ))}

          </select>

        </div>

        {/* Priority */}

        <div className="requirement-filter-item">

          <label>
            Priority
          </label>

          <select
            name="priority"
            value={filters.priority}
            onChange={handleChange}
          >

            <option value="">
              All
            </option>

            {REQUIREMENT_PRIORITIES.map(
              (item) => (
                <option
                  key={item}
                  value={item}
                >
                  {item}
                </option>
              )
            )}

          </select>

        </div>

        {/* From */}

        <div className="requirement-filter-item">

          <label>
            From Date
          </label>

          <input
            type="date"
            name="dateFrom"
            value={filters.dateFrom}
            onChange={handleChange}
          />

        </div>

        {/* To */}

        <div className="requirement-filter-item">

          <label>
            To Date
          </label>

          <input
            type="date"
            name="dateTo"
            value={filters.dateTo}
            onChange={handleChange}
          />

        </div>

        {/* Search */}

        <button
          className="requirement-search-btn"
          onClick={onSearch}
          disabled={loading}
        >

          <FiSearch />

          &nbsp;

          Search

        </button>

        {/* Reset */}

        <button
          className="requirement-reset-btn"
          onClick={onReset}
          disabled={loading}
        >

          <FiRefreshCw />

          &nbsp;

          Reset

        </button>

      </div>

    </div>
  );
};

export default RequirementFilters;